<h1 mat-dialog-title>
  {{ data.title }}
</h1>

<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>

<div class="flex justify-end mb-2 p-4">
  @if (!data.hideCancel) {
    <input [mat-dialog-close]="false" class="btn-cancel" type="button" value="Cancel" />
  }

  @if (data.altLabel) {
    <input [mat-dialog-close]="data.altAction" class="btn-confirm" type="button" value="{{ data.altLabel }}" />
  }
  <input [mat-dialog-close]="true" class="btn-confirm" type="button" value="Confirm" data-testid="confirm_button" />
</div>
